module.exports = __webpack_public_path__ + "static/media/logo-carrorama-fleet.710e401b.webp";